<template>
    <div id="historylist">
        <!-- ----------------------------紀錄查詢開始---------------------------- -->
        <section class="cm-customercenter-history-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('historyList.HistoryListBar')}}
                </div>
            </div>

            <HistoryListContent></HistoryListContent>

            <br/>
            <div class="cm-customercenter-history-banner-line"></div>
        </section>
        <!-- ----------------------------紀錄查詢開始---------------------------- -->
    </div>
</template>

<script>
import router from '@/router.js'
import HistoryListContent from '@/components/HistoryListContent';
import store from "@/store/store-controller/store.js";
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'

export default {
    name: 'historylist',
    components: {
       HistoryListContent
    },
    data() {
        return {
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
        };
    },
    mounted() {
        this.updateTopBackgroundImg();
        
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_HISTORY_LIST, function(i18n) {
            self.updateTopBackgroundImg(i18n);
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);
        
        // 驗證是否為登入狀態，未登入狀態則顯示loginModal讓玩家登入，玩家登入完畢後再回來
        const cookiePair = {}
        if(this.$route.query.cs != undefined) {
            cookiePair[process.env.VUE_APP_COOKIE_HISTORYLIST_QUERY_CS] = this.$route.query.cs
        }
        let verifySetting = {
            verifyStatus: true, // 驗證登入
            from: router.currentRoute.name, // 來源頁面
            setFrontendRouterPushCookie: true, // 是否設置cookie方便登入會導回from設置的頁面
            showLoginModal: true, // 未登入狀態下顯示loginModal
            setCookie: cookiePair
        };
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, verifySetting);
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        }
    }
}
</script>